import {
  Button,
  Center,
  Flex,
  Image,
  Text,
  TextInput,
  ThemeIcon,
  Title,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconMail } from '@tabler/icons';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FingerprintImage from '../../assets/fingerprint-image.svg';
import { Page } from '../../components/page';
import { loadToMemoryDevice, transferBiometric } from '../../data/biometric';
import useAuthContext from '../../hooks/useAuthContext';
import { useBiometric } from '../../hooks/useBiometric';
import { Biometric } from '../../models/biometric';
import { UserRole, UserType } from '../../models/user';
import { errorNotification } from '../../providers/mantine-notifications';
import { AppRoutePaths } from '../../utils/enums/routes';

export function LoginAccessCodeBiometric() {
  //useDisableRightClick();
  const navigation = useNavigate();
  const { loading, biometricLogin, user } = useAuthContext();
  const [transferBiometricLoader, setTransferBiometricLoader] =
    useState<boolean>(false);
  const {
    addBiometricOnStorage,
    loading: createDeviceMemoryLoading,
    deleteAllFromDevice,
  } = useBiometric();

  const formTransferBiometric = useForm({
    initialValues: {
      accessCode: '',
    },
  });

  const handleTransferBiometricSubmit = async ({
    accessCode,
  }: typeof formTransferBiometric.values) => {
    try {
      setTransferBiometricLoader(true);
      const biometric: Biometric = await transferBiometric(accessCode);
      addBiometricOnStorage(biometric);
      setTimeout(async () => {
        await deleteAllFromDevice();
        loadToMemoryDevice([
          { id: biometric.user, template: biometric.template },
        ])
          .then((resp) => {
            if (resp.success) {
              biometricLogin();
              return;
            }
          })
          .catch(() => {
            errorNotification({
              title: 'Falha ao carregar Biometria',
              message: 'tente outro código de acesso.',
            });
          });

        setTransferBiometricLoader(false);
      }, 1000);
    } catch (error) {
      setTransferBiometricLoader(false);
      errorNotification({
        title: 'Usuário não encontrado',
        message: 'tente novamente.',
      });
    }
  };

  useEffect(() => {
    if (
      user?.user.role === UserRole.EMPLOYEE ||
      user?.user.role === UserRole.MONTHLY_EMPLOYEE ||
      user?.user.role === UserRole.DAILY_EMPLOYEE ||
      user?.user.role === UserRole.CLEANING_EMPLOYEE
    ) {
      navigation({ pathname: AppRoutePaths.WORK_HISTORY_CREATE });
    } else if (
      user?.user.type === UserType.MASTER ||
      user?.user.type === UserType.MANAGER
    ) {
      navigation({ pathname: AppRoutePaths.HOME });
    }
  }, [user]);

  return (
    <Page>
      <Center mt="100px">
        <Flex direction={'column'} align={'center'} gap={'xl'}>
          <form
            onSubmit={formTransferBiometric.onSubmit((values) =>
              handleTransferBiometricSubmit(values),
            )}
          >
            <Flex direction={'column'} align={'center'} gap={'xs'}>
              <Flex direction={'column'} align={'center'} gap={'xs'} mb={'lg'}>
                <Image src={FingerprintImage} style={{ width: 140 }} />
                <Title order={2}>Login</Title>
              </Flex>
              <TextInput
                autoComplete="off"
                autoSave="off"
                required
                withAsterisk
                label="Código de acesso"
                placeholder="ex: CAS143S"
                {...formTransferBiometric.getInputProps('accessCode')}
                rightSection={
                  <ThemeIcon color="orange" variant="light">
                    <IconMail size={16} />
                  </ThemeIcon>
                }
                w={'300px'}
              />
              <Button
                type="submit"
                size="md"
                color="indigo"
                pr="50px"
                pl="50px"
                loading={
                  loading ||
                  transferBiometricLoader ||
                  createDeviceMemoryLoading
                }
              >
                Iniciar
              </Button>

              <Text size={'sm'} c="dimmed">
                Clique para iniciar leitura
              </Text>
            </Flex>
          </form>
        </Flex>
      </Center>
    </Page>
  );
}
